<div class="row">
  <div class="col-12 col-md-12 col-sm-12 col-xl-12 mBot10">
    @if (showEditBtn) {
      <button class="primary-btn pull-right"
      (click)="changeAction()">{{editButton}}</button>
    }
  </div>
  <div class="container-title">
    <h3 class="">
      <span class="kx-card-back-icn">
        <i class="fa fa-user" aria-hidden="true"></i>&nbsp;
      </span>
      @if (action === 'MODIFY') {
        <span>Update</span>
        } Your Profile
      </h3>
    </div>
  </div>
  <div class="main-container-body">
    @if (action === 'MODIFY' && userData) {
      <dhs-form [action]="action" [fieldGroup]="currentFields"
        [config]="config" [data]="userData" (saveFinished)="onSaveFinished($event)">
      </dhs-form>
    }
    @if (action === 'VIEW' && userData) {
      <dhs-form-view [fieldGroup]="currentFields"
        (saveFinished)="onSaveFinished($event)" [data]="userData">
      </dhs-form-view>
    }
  </div>